/**
 * @generated SignedSource<<10702370221f5850d1f6c463c62e899f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WikiDataBox_geo$data = {
  readonly area: number | null;
  readonly population: number | null;
  readonly " $fragmentType": "WikiDataBox_geo";
};
export type WikiDataBox_geo$key = {
  readonly " $data"?: WikiDataBox_geo$data;
  readonly " $fragmentSpreads": FragmentRefs<"WikiDataBox_geo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WikiDataBox_geo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "population",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "area",
      "storageKey": null
    }
  ],
  "type": "State",
  "abstractKey": null
};

(node as any).hash = "fb374d8f86362dcaffabb3d86c34101e";

export default node;
